<template>
<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-oracle`]" width="1em" height="1em" v-bind="$attrs"><path d="M5.06 2.93945C2.26672 2.93945 0 5.21048 0 8.00442C0 10.7985 2.26672 13.0595 5.06 13.0595H10.94C13.7339 13.0595 16 10.7985 16 8.00442C16 5.21048 13.7339 2.93945 10.94 2.93945H5.06ZM5.19009 4.72442H10.8099C12.6197 4.72442 14.085 6.19561 14.085 8.00442C14.085 9.81323 12.6197 11.2745 10.8099 11.2745H5.19009C3.38112 11.2745 1.91503 9.8132 1.91503 8.00439C1.91503 6.19558 3.38112 4.72439 5.19009 4.72439V4.72442Z" :fill="useCurrentColor ? 'currentColor' : '#F22301'"/></svg>
</template>
<script>

export default {
  name: 'IconColorOracle',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
